import React from "react";
import { Map } from "immutable";
import AppConstants from "../../constants/AppConstants";
import LottieSelectInput from "./LottieSelectInput";
import LottiePlaybackControls from "./LottiePlaybackControls";
import styles from "./LottieSelectInput.module.css";

const { UPDATE_ACTION_SET, LOTTIE_TYPE_ASSET } = AppConstants;

/**
 * Settings panel for Lottie elements using uploaded asset files.
 * Provides asset selection and playback controls (loop, speed, background color).
 *
 * @param {Object} props
 * @param {Map} props.element - The Lottie element data
 * @param {boolean} props.isLocked - Whether the element is locked
 * @param {Function} props.onPropChange - Callback for property changes
 */
const LottieAssetSettings = ({ element, isLocked, onPropChange }) => {
  const _onAssetChange = (propInfo) => {
    if (propInfo.value === null) {
      onPropChange({
        ...propInfo,
        value: { type: LOTTIE_TYPE_ASSET },
        action: UPDATE_ACTION_SET,
      });
      return;
    }

    const currentContent = element.get("content", Map());
    const currentContentObj = currentContent?.toJS ? currentContent.toJS() : {};
    const newAsset = propInfo.value;

    const mergedContent = {
      ...currentContentObj,
      ...newAsset,
      type: LOTTIE_TYPE_ASSET,
    };

    onPropChange({
      ...propInfo,
      value: mergedContent,
    });
  };

  const lottie = element.get("content", Map());
  const lottieMap = Map.isMap(lottie) ? lottie : Map(lottie || {});
  const hasLottieFile = lottieMap && lottieMap.get("key");

  return (
    <div>
      <LottieSelectInput
        disabled={isLocked}
        propName="content"
        value={lottieMap}
        onChange={_onAssetChange}
        enableDelete={hasLottieFile}
      />
      <p className={`instrux ${styles.instrux}`}>
        <a href="https://learn.showit.com/en/articles/13754801-lottie-animations" target="blank">
          Learn more about Lottie files.
        </a>
      </p>
      <LottiePlaybackControls element={element} isLocked={isLocked} onPropChange={onPropChange} />
    </div>
  );
};

export default LottieAssetSettings;
